import { createContext } from 'react'

import type * as Types from './types'

const defaultValue = {} as Types.UserAgentType

const UserAgentContext = createContext(defaultValue)

export default UserAgentContext